import React from "react";
import { Link } from "react-router-dom";
import NoData from "../NoData";
import { useSelector } from "react-redux";

function NINVerificationStatus() {
  const verificationData = useSelector((state) => state.nin.verificationData);
  if (!verificationData) {
    return (
      <NoData
        title="Uh Oh!"
        message="Verification data not found! Kindly ensure you have provided the correct NIN and try again."
        buttonText="Back to Home"
        buttonLink="/"
      />
    );
  }

  // Check for successful verification based on the presence of nin in the response data.
  const isSuccess = verificationData.nin !== null;

  return (
    <>
      <section className="section-border border-primary">
        <div className="container d-flex flex-column">
          <div className="row align-items-center justify-content-center gx-0 min-vh-100">
            <div className="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11 mt-8">
              <div className="text-center mb-3">
                {isSuccess ? (
                  <i className="fe fe-check-circle text-primary display-3"></i>
                ) : (
                  <i className="fe fe-alert-circle text-danger display-3"></i>
                )}
              </div>
              <h1 className="mb-0 fw-bold text-center text-primary">NIN Verification</h1>
              <p className="mb-6 text-center text-muted">
                {isSuccess
                  ? "You have successfully verified your NIN with us."
                  : "Sorry, we encountered an error verifying your NIN. Please, ensure it is correct and try again."}
              </p>

              <div>
                {isSuccess ? (
                  <Link
                    className="btn w-100 btn-primary"
                    to={`/onboarding?tid=${verificationData.tid}`}
                    replace
                    aria-label="Continue to Onboarding"
                  >
                    Continue to Onboarding
                  </Link>
                ) : (
                  <Link
                    className="btn w-100 btn-outline-primary"
                    to="/signup"
                    replace
                    aria-label="Back to Signup"
                  >
                    Back to Signup
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NINVerificationStatus;
